import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  icon: {
    display: 'block',
    maxWidth: 120,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(4),
  },
  panelRoot: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    margin: '0 !important',

    '&::before': {
      display: 'none',
    },
  },
  panelSummary: {
    padding: 0,
  },
  panelSummaryIcon: {
    order: -1,
    marginRight: theme.spacing(1),
  },
  titleFaq: {
    color: '#7833FF',
    fontSize: 34,
    lineHeight: 1.3,
    fontWeight: 'Bold',
    paddingBottom: 15,

    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
  },
}));
